import { render, staticRenderFns } from "./Index2.vue?vue&type=template&id=7005e07d&scoped=true"
import script from "./Index2.vue?vue&type=script&lang=js"
export * from "./Index2.vue?vue&type=script&lang=js"
import style0 from "./Index2.vue?vue&type=style&index=0&id=7005e07d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7005e07d",
  null
  
)

export default component.exports